import React from 'react'
import {useMultiStyleConfig, StackProps, useDisclosure, VStack, HStack} from '@chakra-ui/react'
import {Loader, IconButton, Icon, ShareBox} from '_uiComponents'

interface ZoomModalHeaderProps {
    isActionLoading: boolean
    isInWishlist: boolean
    addToWishlistAriaLabel: string
    onAddToWishlist: () => void | Promise<void>
    shareUrl: string
    shareSubject: string
}

/**
 * Stable top-level component so React can reconcile it in-place (update props)
 * without unmounting when ModalContext re-renders via updateModalTitle.
 * If defined inline inside ProductDetails, every render creates a new function
 * reference → React unmounts + remounts → internal useDisclosure state is lost.
 */
const ZoomModalHeader: React.FC<ZoomModalHeaderProps> = ({isActionLoading, isInWishlist, addToWishlistAriaLabel, onAddToWishlist, shareUrl, shareSubject}) => {
    const zoomStyles = useMultiStyleConfig('ZoomImageModal', {}) as Record<string, StackProps>
    const {isOpen: isShareOpen, onToggle: onToggleShare, onClose: onCloseShare} = useDisclosure()

    return (
        <VStack className="cc-zoompdp__ctablock" {...zoomStyles.ctaButtonsZoomWrapper}>
            {isActionLoading && <Loader />}

            <IconButton
                icon={<Icon name="IconHeart" size="tile-button" isFilled={isInWishlist} />}
                size="iconButtonLg"
                isRounded={true}
                variant="iconButtonBgTransparent"
                aria-label={addToWishlistAriaLabel}
                onClick={() => void onAddToWishlist()}
                data-testid="pdp-add-to-wishlist-button"
            />

            <ShareBox isOpen={isShareOpen} onClose={onCloseShare} shareUrl={shareUrl} shareSubject={shareSubject} anchorNearEdge>
                <HStack as="button" {...zoomStyles.quickShareButton} onClick={onToggleShare}>
                    <Icon name="IconShare" size="md" />
                </HStack>
            </ShareBox>
        </VStack>
    )
}

ZoomModalHeader.displayName = 'ZoomModalHeader'

export default ZoomModalHeader
